import * as React from "react";
import createNotificationOpener from "./helpers/createNotificationOpener";

export { default as NotificationsContainer } from './components/NotificationsContainer';
export { default as createNotificationOpener } from "./helpers/createNotificationOpener";
export { default as notifyError } from "./helpers/notifyError";

export const openMessage = createNotificationOpener(React.lazy(() => import('./components/NotificationMessage')));
